import { Td, Tr } from "@chakra-ui/react";
import MenuBox from "components/Menu/MenuIntegracionBox/MainMenu";
import { useContext, useState } from "react";
import IntegracionBoxCrudContex from "context/IntegracionBoxCrudContex";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import environment from "constants/apiConst";
import { useSelector } from "react-redux";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import { __Post } from "request/Petitions/__Post";

const TbodyBox = ({ data }) => {
  const location = useLocation();
  const { pathname } = location;
  const token = useSelector((state) => state.auth.dataUser.token);
  const [openAlert] = AlertErrorAlert()
  const [openMenu, setOpenMenu] = useState(true);

  const checkIfItIsBlocked = async () => {
    const body = new FormData();
    body.append("form_id", data?.integration_certificate_id);
    body.append("type_of", "CI");
    body.append("type", 4);
    const res = await __Post(environment.FORMS_ON_REVIEW, token, body);
    if (res?.data?.status?.code === 200) {
      setOpenMenu(true)
    }
    if (res?.data?.status?.code === 400) {
      openAlert(res?.data?.status?.message, "error");
      setOpenMenu(false)
      setTimeout(() => setOpenMenu(true), 500)
    }
  }

  return (
    <Tr>
      <Td className="text-center">
        <NavLink
          to={`/ShowIntegrationBox?id=${data?.integration_certificate_id}`}
        >
          <span className="formNumber">{data?.integration_certificate_code}</span>
        </NavLink>
      </Td>

      <Td className="text-center">{data?.qualified_users_nit}</Td>
      <Td className="text-center">{data?.qualified_users_name}</Td>
      <Td className="text-center">{data?.destiny}</Td>
      <Td className="text-center">{data?.status}</Td>
      {data?.status === "PRESENTADO"
        ? (
          <Td className="text-center" onClick={() => checkIfItIsBlocked()}>
            {openMenu && <MenuBox data={data} />}
          </Td>
        )
        : (
          pathname === "/TabletIntegrationCorrected" &&
            data.status === "AUTORIZADO"
            ? (
              <Td className="text-center">N/A</Td>
            )
            : (
              <Td className="text-center" isNumeric>
                <MenuBox data={data} />
              </Td>
            ))}
    </Tr>
  );
};

export default TbodyBox;
